import { useEffect } from "react";
import Header from "../components/Header";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import CallButton from "../components/CallButton";

export default function ContactPage() {
  useEffect(() => {
    document.title = "Επικοινωνία | Ορίζοντες Ανάπτυξης — Κέντρο Ειδικών Θεραπειών στο Περιστέρι";
    const desc = document.querySelector('meta[name="description"]');
    if (desc)
      desc.setAttribute(
        "content",
        "Επικοινωνήστε με το Κέντρο Ειδικών Θεραπειών «Ορίζοντες Ανάπτυξης» στο Περιστέρι. Τηλέφωνο 210 571 9375, φόρμα επικοινωνίας, χάρτης, διεύθυνση και ωράριο λειτουργίας."
      );
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", "https://orizontesanaptixis.gr/epikoinonia");
    window.scrollTo(0, 0);
    return () => {
      document.title = "Ορίζοντες Ανάπτυξης | Κέντρο Ειδικών Θεραπειών στο Περιστέρι";
      if (desc)
        desc.setAttribute(
          "content",
          "Κέντρο Ειδικών Θεραπειών «Ορίζοντες Ανάπτυξης» στο Περιστέρι. Λογοθεραπεία, Εργοθεραπεία, Ψυχολογική Υποστήριξη, Πρώιμη Παρέμβαση & Συμβουλευτική Γονέων. Δωρεάν αξιολόγηση για κάθε παιδί."
        );
      if (canonical) canonical.setAttribute("href", "https://orizontesanaptixis.gr/");
    };
  }, []);

  return (
    <div data-testid="contact-page" className="min-h-screen bg-brand-bg">
      <Header />
      <main className="pt-8">
        <Contact />
      </main>
      <Footer />
      <CallButton />
    </div>
  );
}
